import { formatMoney } from "../utils/pricing";
import "./ProductPrice.css";

type ProductPriceProps = {
  compareAtPrice: number;
  price: number;
  className?: string;
  dataTest?: string;
  discountTag?: string;
};

export function ProductPrice({
  compareAtPrice,
  price,
  className,
  dataTest,
  discountTag,
}: ProductPriceProps) {
  const discountPercentage = Math.floor((1 - price / compareAtPrice) * 100);
  return (
    <div
      className={`react-pdp__onetime-price-row${className ? " " + className : ""}`}
      data-test={dataTest}
    >
      <div className="react-pdp__onetime-prices">
        {compareAtPrice > price ? (
          <span className="react-pdp__onetime-compare-price">
            {formatMoney(compareAtPrice)}
          </span>
        ) : null}
        <span className="react-pdp__onetime-price">{formatMoney(price)}</span>
        {discountTag && (
          <div className="react-pdp__onetime-discount">
            <span className="material-symbols-rounded">sell</span>
            <span className="react-pdp__onetime-discount-tag">
              {discountTag} -{discountPercentage}%
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
